import React, {useState} from 'react'
import {
  Box,
  Grid2,
  OutlinedInput
} from "@mui/material";
import ListingPageFilter from './ListingPageFilter';
import "../../styles/ListingPageFilter.css";

const SearchFilter = ({childComponent, filterCondition,typeId, placeholder, defaultValue, searchPage, defaultFilterValue}) => {

  const [searchParams, setSearchTerm] = useState(localStorage.getItem("SearchParams") ? localStorage.getItem("SearchParams") : "");
  let filterVal;
  if(localStorage.getItem("FilterParams") && localStorage.getItem("FilterParams") !== "All"){
    filterVal = localStorage.getItem("FilterParams")
  } else if (localStorage.getItem("FilterParams") && localStorage.getItem("FilterParams") === "All") {
    filterVal = undefined;
  } else {
    filterVal = defaultFilterValue !== "All" ? defaultFilterValue : undefined;
  }
  const [filterParams, setFilterParams] = useState({
    miles: filterVal,
    sortBy: localStorage.getItem("SortByParams") ? 
      localStorage.getItem("SortByParams") : defaultValue ? defaultValue : undefined,
  });

  const handleSearch = (e) => {
    const value = e?.target?.value?.replace(/[^a-zA-Z ]+/ig, "")?.replace(/\s\s+/g, " ")?.trimStart();
    setSearchTerm(value);
    localStorage.setItem("SearchParams", value);
    localStorage.setItem("SearchParamsChanged", value);
  };

  const applyFilter = (filtered) => {
    setFilterParams(filtered);
  }

  return (
    <Box >
        {/* SEARCH AND FILTER */}
        <Box
            style={{
              display: "flex",
              justifyContent: "space-between",  
            }}
            sx={{ marginY: "1rem", }}
          >
              <OutlinedInput
                className="search-bar"
                placeholder={placeholder ? placeholder : "Search by city name"}
                value={searchParams}
                type='text'
                onChange={handleSearch}
                inputProps={{ maxLength: 30 }}
                size='small'
                startAdornment= {
                  <div style={{marginTop:"0.3rem", paddingRight:"0.3rem"}}>
                      <img src={require("../../assets/logos/search.svg").default} alt="mySearchImage" width='20px' height='20px' />
                  </div>
                }
              />
             {typeId!==0 ?<ListingPageFilter type={typeId} applyFilter={applyFilter} defaultValue={defaultValue} defaultFilterValue={defaultFilterValue} sortList={searchPage} />:<></>}
          </Box>

        {/* TABLE WITH DATA */}
        <Grid2>
          {React.cloneElement(childComponent, { searchParams, filterParams })}
        </Grid2>
    </Box>
  )
}

export default React.memo(SearchFilter)


